import React from 'react'

export const BeforeAfter = () => {
  return (
    <div className="flex mt-12 gap-3">
      <div className="bg-[#D7412A1F] w-full rounded-2xl relative flex flex-col">
        <span className="absolute top-4 left-1/2 -translate-x-1/2 text-center text-[#D7412A] font-semibold">
          Before
        </span>
        <img className="w-full aspect-[194/190]" src="/quiz/images/before.png" alt="vector" />
        <div className="bg-[#FFF3F1] py-5 px-6 rounded-2xl grow">
          <div>
            <span className="text-[12px] block text-[#D7412AB2] font-medium">Storage</span>
            <p className="text-[#D7412A] text-base font-semibold">Almost full</p>
          </div>

          <div className="mt-3">
            <span className="text-[12px] block text-[#D7412AB2] font-medium">Spam alerts</span>
            <p className="text-[#D7412A] text-base font-semibold">Too many</p>
          </div>

          <div className="mt-3">
            <span className="text-[12px] block text-[#D7412AB2] font-medium">Performance</span>
            <p className="text-[#D7412A] text-base font-semibold">Slow</p>
            <div className="flex gap-1 mt-3">
              <span className="block w-full h-1 rounded-sm bg-[#D7412A]"></span>
              <span className="block w-full h-1 rounded-sm bg-[#D7412A]"></span>
              <span className="block w-full h-1 rounded-sm bg-[#D7412A] opacity-10"></span>
              <span className="block w-full h-1 rounded-sm bg-[#D7412A] opacity-10"></span>
              <span className="block w-full h-1 rounded-sm bg-[#D7412A] opacity-10"></span>
              <span className="block w-full h-1 rounded-sm bg-[#D7412A] opacity-10"></span>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#34976024] w-full rounded-2xl relative flex flex-col">
        <span className="absolute top-4 left-1/2 -translate-x-1/2 text-center text-[#349760] font-semibold">
          After
        </span>
        <img className="w-full aspect-[194/190]" src="/quiz/images/after.png" alt="vector" />
        <div className="bg-[#E6F6EE] py-5 px-6 rounded-2xl grow">
          <div>
            <span className="text-[12px] block text-[#349760B2] font-medium">Storage</span>
            <p className="text-[#349760] text-base font-semibold">Clean</p>
          </div>

          <div className="mt-3">
            <span className="text-[12px] block text-[#349760B2] font-medium">Spam alerts</span>
            <p className="text-[#349760] text-base font-semibold">Blocked</p>
          </div>

          <div className="mt-3">
            <span className="text-[12px] block text-[#349760B2] font-medium">Performance</span>
            <p className="text-[#349760] text-base font-semibold">Fast</p>
            <div className="flex gap-1 mt-3">
              <span className="block w-full h-1 rounded-sm bg-[#349760]"></span>
              <span className="block w-full h-1 rounded-sm bg-[#349760]"></span>
              <span className="block w-full h-1 rounded-sm bg-[#349760]"></span>
              <span className="block w-full h-1 rounded-sm bg-[#349760]"></span>
              <span className="block w-full h-1 rounded-sm bg-[#349760]"></span>
              <span className="block w-full h-1 rounded-sm bg-[#349760]"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
